import { useOidc } from '@/features/oidc/oidc'
import { TrackingProvider } from '@vgw/multibrand-fe-tracking'
import { ReactNode } from 'react'

interface TrackingProps {
  apiKey: string
  children: ReactNode
}

export const Tracking = ({ apiKey, children }: TrackingProps) => {
  const { decodedIdToken, isUserLoggedIn } = useOidc()

  return (
    <TrackingProvider
      apiKey={apiKey}
      isUserLoggedIn={isUserLoggedIn}
      pamAccountId={decodedIdToken?.['pam-aid'] as string}
    >
      {children}
    </TrackingProvider>
  )
}
